<div class="l-top-navi" role="navigation">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <h1 class="l-top-navi__heading-text" [innerHTML]="'heading.completedServiceRequest' | staticMsg"></h1>
      </div>
    </div>
  </div>
</div>
